import React, { useContext } from 'react';
import Backdrop from '../../components/modal/backdrop.component';
import DespachoMap from '../../components/mapbox/despachomap.component';
import userIcon from '../../assets/images/iconos/icono-017.png';
import moment from 'moment';
import ModalImage from "react-modal-image";
import {
    faTimes,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ConfigContext } from '../../context/config.context';


const SlideDrawer = ({ show, onClose, data }) => {

    let drawerClasses = 'side-drawer';
    if (show) {
       drawerClasses = 'side-drawer open';
    }

    const { config } = useContext(ConfigContext);

    return (
        <>
            <Backdrop show={show}/>
            <div className={drawerClasses}>
             { show && 
                <div className="map-container-despacho">
                    <div onClick={onClose} className="closed-modal-lateral">
                        <FontAwesomeIcon icon={faTimes} />
                        <div className="btn-close-drawer">
                            <small>GUIA</small>
                            <div>{config.prefijo_correlativo_guia}-{data.guia_paquete}</div>
                        </div>
                    </div>
                    {show &&
                        !data.latitud ? 
                            <div className="not-geo">
                                <small>No posee geolocalización</small>
                            </div>
                        :
                            <DespachoMap
                                data={data}
                            />
                    }
                </div>
            }
            {data && show &&
                <>
                    <div className="d-flex flex-row box-profile-container">
                        <div className="d-flex flex-row align-items-center profile-container">
                            <div className="profile-user" style={{ backgroundImage: data.depacho_usuario.imagen_perfil ? `url(https://awsjupiter21.s3.amazonaws.com/DIBOXAPP/perfiles_app/${data.depacho_usuario.imagen_perfil})` : userIcon }}>    
                            </div>
                            <div className="user-information-app">
                                <h2>{data.depacho_usuario.nombre_usuario}</h2>
                                <small>Repartidor puerta a puerta</small>
                            </div>
                        </div>
                        <div className="d-flex align-items-center justify-content-center box-info-despacho border-info-box">
                            <div className="info-context">
                                <small>Fecha de entrega</small>
                                <div>{moment(data.fecha_entrega).format('DD/MM/YYYY')}</div>
                            </div>
                        </div>
                        <div className="d-flex align-items-center justify-content-center box-info-despacho">
                            <div className="info-context">
                                <small>Hora de entrega</small>
                                <div>{data.hora_entrega}</div>
                            </div>
                        </div>
                    </div>
                    <div className="box-profile-container">
                        <div className="user-information-app">
                            <h2>Dirección de entrega</h2>
                            <small>{data.despacho_guia.cliente_receptor_direccion_entrega}</small>
                        </div>
                    </div>
                    <div className="box-profile-container">
                        <div className="user-information-app">
                            <h2>Observación</h2>
                            <small>{data.observacion}</small>
                        </div>
                    </div>
                    <div className="box-profile-container d-flex flex-row">
                        {data.image_firma_entrega && 
                            <div className="user-information-app" style={{ width: '50%' }}>
                                <h2 className="mb-1">Firma conforme</h2>
                                <ModalImage
                                    className="box-image-modal-sign"
                                    small={`https://awsjupiter21.s3.amazonaws.com/DIBOXAPP/app-demo/${data.image_firma_entrega}`}
                                    large={`https://awsjupiter21.s3.amazonaws.com/DIBOXAPP/app-demo/${data.image_firma_entrega}`}
                                    alt="Firma confome del cliente"
                                    hideZoom={true}
                                    hideDownload={true}
                                />
                            </div>
                        }
                        {data.imagen_entrega && 
                            <div className="user-information-app" style={{ width: '50%' }}>
                                <h2 className="mb-1">Foto entrega</h2>
                                <ModalImage
                                    className="box-image-modal"
                                    small={`https://awsjupiter21.s3.amazonaws.com/DIBOXAPP/app-demo/${data.imagen_entrega}`}
                                    medium={`https://awsjupiter21.s3.amazonaws.com/DIBOXAPP/app-demo/${data.imagen_entrega}`}
                                    alt="Comprobante de entrega"
                                    hideZoom={true}
                                    hideDownload={true}
                                />
                            </div>
                        }
                    </div>
                    
                </>
             }
            </div>
        </>
    )
}

export default SlideDrawer;